<section [class.section-outset-y]="hasHeader && !hasDarkTheme">
  <ul class="content-block-list" *ngIf="cookiePreferences$() as cookies">
    <li
      class="content-block-list__item position-relative"
      *ngFor="let block of blocks; trackBy: trackByFn; let i = index"
      [ngSwitch]="block.blockType"
      [ngClass]="'type--' + block.blockType"
      [id]="'blok-' + i"
      [class.scroll-trigger]="!hasBlocksInBlocks(block)"
      [class.scroll-trigger-2]="!hasBlocksInBlocks(block)"
      [attr.data-is-dark]="block?.hasDarkTheme || blockHasDarkTheme(block)"
      [attr.data-blocktype]="block.blockType"
    >
      <!-- <app-content-block-default [index]="i" [block]="block" *ngSwitchCase="'block-image'"></app-content-block-default> -->

      <hr class="skew--tl" *ngIf="block.blockType === 'block-cta'" />

      <app-content-block-case
        [index]="i"
        [block]="block"
        [cookiePreferences]="cookies"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        *ngSwitchCase="'block-case'"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-case>
      <app-content-block-usp
        [index]="i"
        [block]="block"
        [cookiePreferences]="cookies"
        *ngSwitchCase="'block-usp'"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-usp>
      <app-content-block-introduction
        [index]="i"
        [block]="block"
        [cookiePreferences]="cookies"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        *ngSwitchCase="'block-introduction'"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-introduction>
      <app-content-block-partner
        [index]="i"
        [block]="block"
        [cookiePreferences]="cookies"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        *ngSwitchCase="'block-partner'"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-partner>
      <app-content-block-service
        [index]="i"
        [block]="block"
        [cookiePreferences]="cookies"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        *ngSwitchCase="'block-service'"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-service>
      <app-content-block-cta
        [index]="i"
        [block]="block"
        [cookiePreferences]="cookies"
        *ngSwitchCase="'block-cta'"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-cta>
      <app-content-block-question
        [index]="i"
        [block]="block"
        [cookiePreferences]="cookies"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        *ngSwitchCase="'block-question'"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-question>
      <app-content-block-featured
        [index]="i"
        [block]="block"
        [cookiePreferences]="cookies"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        *ngSwitchCase="'block-featured'"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-featured>
      <app-content-block-navigation
        [index]="i"
        [block]="block"
        [cookiePreferences]="cookies"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        *ngSwitchCase="'block-navigation'"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-navigation>
      <app-content-block-carroussel
        [index]="i"
        [block]="block"
        [cookiePreferences]="cookies"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        *ngSwitchCase="'block-carroussel'"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-carroussel>
      <app-content-block-team
        [index]="i"
        [block]="block"
        [cookiePreferences]="cookies"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        *ngSwitchCase="'block-team'"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-team>
      <app-content-block-maas-default
        [index]="i"
        [block]="block"
        [hasDarkTheme]="hasDarkTheme"
        [cookiePreferences]="cookies"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        [activeScrollTrigger]="activeScrollTrigger || []"
        *ngSwitchCase="'block-default'"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-maas-default>
      <app-content-block-contact
        [index]="i"
        [block]="block"
        [hasHeader]="false"
        [cookiePreferences]="cookies"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        *ngSwitchCase="'block-contact'"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-contact>
      <app-content-block-wysiwyg
        [index]="i"
        [block]="block"
        [cookiePreferences]="cookies"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        *ngSwitchCase="'block-wysiwyg'"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-wysiwyg>
      <app-content-block-fullwidth-image
        [index]="i"
        [block]="block"
        [cookiePreferences]="cookies"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        *ngSwitchCase="'block-fullwidth-image'"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-fullwidth-image>
      <app-content-block-teamv2
        [index]="i"
        [block]="block"
        [cookiePreferences]="cookies"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        *ngSwitchCase="'block-teamv2'"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-teamv2>
      <app-content-block-play-cta
        class="position-relative d-block"
        [index]="i"
        [block]="block"
        [cookiePreferences]="cookies"
        *ngSwitchCase="'block-play-cta'"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-play-cta>
      <app-content-block-play-cta-end
        class="position-relative d-block"
        [index]="i"
        [block]="block"
        [cookiePreferences]="cookies"
        *ngSwitchCase="'block-play-cta-end'"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-play-cta-end>
      <app-content-block-play-slide
        [index]="i"
        [block]="block"
        [cookiePreferences]="cookies"
        [inviewPortTrigger]="activeScrollTrigger?.includes('blok-' + i) || false"
        *ngSwitchCase="'block-play-slide'"
        [activeScrollTrigger]="activeScrollTrigger || []"
        (themeChange)="onThemeChange($event)"
      ></app-content-block-play-slide>

      <hr class="skew--br" *ngIf="block.blockType === 'block-service' || block.blockType === 'block-featured'" />
    </li>
  </ul>
</section>
